<template>
  <div>
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('addedServices', 'customSettings')" name="first">
        <customSettings v-if="activeName == 'first'" />
      </el-tab-pane>
      <el-tab-pane :label="$t('addedServices', 'categoryManagement')" name="second">
         <classifiedManagement v-if="activeName == 'second'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import customSettings from './components/customSettings';
import classifiedManagement from './components/classifiedManagement';
import i18nMixin from '@/mixins/i18nMixin';
export default {
  mixins: [i18nMixin],
  data() {
    return {
      activeName: "first",
    };
  },
  components:{
    customSettings,
    classifiedManagement
  },
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>